import React, {memo} from "react";

export const IconAgreement = memo(({color, addClass}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className={addClass}
    >
      <g clipPath="url(#clip0_25895_529)">
        <path
          d="M19.4978 13.379L16.4978 1.379C16.4408 1.152 16.2368 1 16.0128 1C16.0088 1 16.0058 1 16.0018 1H4.02381C3.99481 0.999 3.96581 1.001 3.93581 1.006C3.90281 1.011 3.86981 1.02 3.83881 1.031C3.75281 1.063 3.68081 1.116 3.62581 1.183C3.59481 1.22 3.56981 1.262 3.55081 1.308C3.53981 1.334 3.53181 1.361 3.52481 1.388L0.526808 13.378C0.506808 13.459 0.507808 13.542 0.527808 13.62H0.526808C0.542808 13.683 0.695808 14.254 1.19781 14.828C1.66481 15.362 2.53281 15.999 4.01181 15.999C5.49081 15.999 6.35781 15.362 6.82581 14.828C7.32781 14.254 7.48181 13.683 7.49681 13.62H7.49581C7.51581 13.541 7.51681 13.458 7.49681 13.378L4.65181 1.999H15.3708L12.5258 13.378C12.5058 13.459 12.5068 13.542 12.5268 13.62H12.5258C12.5418 13.683 12.6948 14.254 13.1968 14.828C13.6638 15.362 14.5318 15.999 16.0108 15.999C17.4898 15.999 18.3568 15.362 18.8248 14.828C19.3268 14.254 19.4808 13.683 19.4958 13.62H19.4948C19.5148 13.541 19.5158 13.458 19.4958 13.378L19.4978 13.379ZM4.01281 15C2.79881 15 2.14781 14.458 1.81481 14H6.21181C5.87881 14.458 5.22781 15 4.01381 15H4.01281ZM6.37281 13H1.65381L4.01381 3.562L6.37381 13H6.37281ZM16.0128 3.562L18.3728 13H13.6538L16.0138 3.562H16.0128ZM16.0128 15C14.7988 15 14.1478 14.458 13.8148 14H18.2118C17.8788 14.458 17.2278 15 16.0138 15H16.0128Z"
          fill={color || "black"}
        />
        <path
          d="M16.0128 18H10.5528L11.5118 5.538C11.5168 5.472 11.5088 5.405 11.4878 5.342L10.4878 2.342C10.4198 2.138 10.2288 2 10.0138 2C9.79882 2 9.60782 2.138 9.53982 2.342L8.53982 5.342C8.51882 5.405 8.51082 5.472 8.51582 5.538L9.47482 18H4.01482C3.73882 18 3.51482 18.224 3.51482 18.5C3.51482 18.776 3.73882 19 4.01482 19H16.0148C16.2908 19 16.5148 18.776 16.5148 18.5C16.5148 18.224 16.2908 18 16.0148 18H16.0128ZM10.0128 4.081L10.5068 5.562L10.0128 11.98L9.51882 5.562L10.0128 4.081Z"
          fill={color || "black"}
        />
      </g>
      <defs>
        <clipPath id="clip0_25895_529">
          <rect width="20" height="20" fill="white" transform="translate(0.512817)" />
        </clipPath>
      </defs>
    </svg>
  );
});
